@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Multi Package Extras</h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Choose an extra and the packages that already sell it are ticked. Tick more to add it, untick to
        take it off, then save.
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="field mb-4">
          <label class="font-medium block mb-2">Extra</label>
          <p-select [options]="ListExtras" [(ngModel)]="selectedExtra" optionLabel="name" placeholder="Choose an extra"
            [filter]="true" filterBy="name" [showClear]="true" [style]="{'width': '420px'}"
          emptyMessage="No extras available" (onChange)="extraChanged()" (onClear)="extraChanged()"></p-select>
        </div>
        <!-- What the chosen extra is, straight from the extra itself. Read only here: changing any
        of it would change the extra everywhere it is already sold. Min and Max are the
        exception, because those belong to the package, not to the extra. -->
        @if (selectedExtra) {
          <div class="mpx-details">
            <div class="mpx-details-head">
              @if (selectedExtra.imageurl) {
                <div class="mpx-thumb">
                  <img [src]="selectedExtra.imageurl" alt="" (error)="$any($event.target).hidden = true">
                </div>
              }
              <div class="mpx-details-title">
                <div class="mpx-detail-name">{{selectedExtra.name}}</div>
                @if (showSelectedDescription) {
                  <div class="mpx-detail-desc">{{selectedExtra.description}}</div>
                }
              </div>
              <div class="mpx-price">
                <span class="mpx-price-value">{{selectedExtra.price | currency:CurrencySymbol}}</span>
                <span class="mpx-price-basis">{{selectedExtra.perPerson ? 'per booking' : 'per extra'}}</span>
              </div>
            </div>
            <div class="mpx-detail-grid">
              <div class="mpx-detail">
                <span class="mpx-detail-label">Available on</span>
                <span class="mpx-detail-value">{{selectedExtraDays}}</span>
              </div>
              <div class="mpx-detail">
                <span class="mpx-detail-label">Venue only</span>
                <span class="mpx-detail-value">{{selectedExtra.venueextras ? 'Yes' : 'No'}}</span>
              </div>
              @if (selectedExtra.question) {
                <div class="mpx-detail mpx-detail--wide">
                  <span class="mpx-detail-label">Question asked</span>
                  <span class="mpx-detail-value">{{selectedExtra.question}}</span>
                </div>
              }
            </div>
            <!-- Min and Max sit with the extra's details, but unlike the rest they can be set: they
            belong to the package, not to the extra. -->
            <div class="mpx-limits">
              <div class="field">
                <label class="font-medium">Min</label>
                <p-inputnumber [ngModel]="minValue" (ngModelChange)="minValue = $event; minChanged()" [showButtons]="true" [max]="minBoxMax" [min]="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
              </div>
              <div class="field">
                <label class="font-medium">Max</label>
                <p-inputnumber [ngModel]="maxValue" (ngModelChange)="maxValue = $event; maxChanged()" [showButtons]="true" [max]="100" [min]="maxBoxMin" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
              </div>
            </div>
          </div>
        }
        @if (selectedExtra) {
          <div class="grid">
            <div class="col-12">
              <label class="font-medium">Packages <span class="mpx-count">{{selectedPackages.length}} ticked</span></label>
              @if (selectedExtra && !packagesKnowExtras) {
                <p class="mpx-warn">
                  <span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>
                  The packages list came back without their extras, so nothing could be ticked for you.
                  Tick a package to add the extra to it. Unticking cannot remove anything here, because
                  the page cannot tell what each package already sells.
                </p>
              }
              <span class="p-input-icon-left mpx-search">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="packagesTable.filterGlobal($any($event.target).value, 'contains')" placeholder="Package Name" />
              </span>
              <p-table #packagesTable [value]="ListPackages" [(selection)]="selectedPackages" dataKey="packageId"
                [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50]" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                [globalFilterFields]="['name']" responsiveLayout="scroll" sortField="name">
                <ng-template #header>
                  <tr>
                    <th style="width:3rem"><p-tableheadercheckbox></p-tableheadercheckbox></th>
                    <th pSortableColumn="name">Name <p-sorticon field="name"></p-sorticon></th>
                    @if (selectedExtra) {
                      <th style="width:10rem">Has this extra</th>
                    }
                  </tr>
                </ng-template>
                <ng-template #body let-data>
                  <tr>
                    <td><p-tablecheckbox [value]="data"></p-tablecheckbox></td>
                    <td>{{data.name}}</td>
                    <!-- What the package sells now, as saved. The tick boxes say what it should
                    sell once the changes are saved. -->
                    @if (selectedExtra) {
                      <td>
                        @if (packageHasExtra(data)) {
                          <span class="mpx-tickmark pi pi-check" title="This package already sells this extra"></span>
                        }
                      </td>
                    }
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr><td colspan="3"><i>No packages available.</i></td></tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        }
        @if (running) {
          <div class="mpx-progress">
            <p-progressbar [value]="(progressDone / progressTotal) * 100"></p-progressbar>
            <div class="mpx-progress-text">Saving package {{progressDone}} of {{progressTotal}}. Please leave this page open.</div>
          </div>
        }
        @if (changeCount > 0 && !running) {
          <div class="mpx-unsaved">
            <span class="pi pi-exclamation-circle" style="margin-right:8px;"></span>
            You have changed {{changeCount}} {{changeCount == 1 ? 'package' : 'packages'}}. Nothing happens until
            you press Save changes, and leaving this page now would lose it.
          </div>
        }
        <div class="mt-3">
          <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" [disabled]="!canApply" (click)="askToApply()">
            <span class="pi pi-check" style="margin-right:8px;"></span>
            Save changes@if (changeCount > 0) {
            <span>&nbsp;({{changeCount}})</span>
          }
        </button>
        &nbsp;
        <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" [disabled]="running" (click)="returnToList()">
          <span class="pi pi-times" style="margin-right:8px;"></span>
          Cancel
        </button>
      </div>
    </div>
    @if (resultsVisible) {
      <div class="surface-card p-4 shadow-2 border-round mt-4">
        <div class="text-900 font-medium text-xl mb-3"><h3>What happened</h3></div>
        @if (failedCount > 0) {
          <p class="mpx-warn">
            <span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>
            {{failedCount}} of {{results.length}} packages could not be saved. Those packages have not been changed.
          </p>
        }
        <p-table [value]="results" responsiveLayout="scroll">
          <ng-template #header>
            <tr>
              <th style="width:40%">Package</th>
              <th>Result</th>
            </tr>
          </ng-template>
          <ng-template #body let-result>
            <tr [ngStyle]="{'background-color': result.failed ? '#fee' : '#ffffff'}">
              <td>{{result.name}}</td>
              <td>{{result.detail}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>
</div>
}

<p-dialog header="Are you sure?" [(visible)]="confirmVisible" [modal]="true" [style]="{width: '460px'}" [draggable]="false" [resizable]="false">
  @if (selectedExtra) {
    <div>
      @if (packagesToAdd.length > 0) {
        <p class="line-height-3">
          <b>{{selectedExtra.name}}</b> will be added to
          {{packagesToAdd.length}} {{packagesToAdd.length == 1 ? 'package' : 'packages'}}, with a Min of
          {{minValue}} and a Max of {{chosenMax}}.
        </p>
      }
      @if (packagesToRemove.length > 0) {
        <p class="line-height-3">
          <b>{{selectedExtra.name}}</b> will be taken off
          {{packagesToRemove.length}} {{packagesToRemove.length == 1 ? 'package' : 'packages'}}. Bookings
          already taken are not affected, but it can no longer be sold on {{packagesToRemove.length == 1 ? 'that package' : 'those packages'}}.
        </p>
      }
    </div>
  }
  <ng-template #footer>
    <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto" (click)="confirmVisible = false">
      <span class="pi pi-times" style="margin-right:8px;"></span>
      No, go back
    </button>
    <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto" (click)="apply()">
      <span class="pi pi-check" style="margin-right:8px;"></span>
      Yes, do it
    </button>
  </ng-template>
</p-dialog>
